import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { setMomentLocale } from '@utils/date';

import en from './locales/en.json';
import ko from './locales/ko.json';

const { language } = navigator;
const resources = {
  ko: { translation: ko },
  en: { translation: en },
};

const callbackChangeLocale = (lang: string) => {
  setMomentLocale(lang);
  document.title = i18n.t('카카오워크 설문');
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: language === 'ko' || language === 'ko-KR' ? 'ko' : 'en',
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    keySeparator: false,
    nsSeparator: false,
    returnNull: false,
    interpolation: {
      escapeValue: false,
      prefix: '{',
      suffix: '}',
    },
    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br'],
      useSuspense: false,
    },
  })
  .then(() => callbackChangeLocale(i18n.language));

i18n.changeLanguage().then(() => callbackChangeLocale(i18n.language));
export default i18n;
